import React from 'react'
import { withAuthorization, withAuthentication } from '../Session'
import { compose } from 'recompose'
import { ROLES } from '../../constants'
import { Switch } from 'react-router-dom'
import * as ROUTES from '../../constants/routes'

import { Container, Divider, Grid, Modal, Tab } from 'semantic-ui-react'
import SearchComponent from '../Form/search'
import TableComponent from '../Table'
import list from './config/jobs-list'
import search from './config/search'
import { AutoHeader, TranslatedButton, Page, MandatoryWarning } from '../Common'
import { pageKey } from '../Helpers'
import { TabWidget } from '../Widgets'
import { labelHelper } from '../Helpers'
import labels from '../Common/translations'
import JobShowPage from './show'
import JobDefinitionCreatePage from './create-definition'

const JobsPage = () => (
   <div>
      <Switch>
         <Page
            exact
            path={ROUTES.JOBS}
            component={JobsList}
            title="screens.jobs"
         />
         <Page
            path={ROUTES.JOBS_SHOW}
            component={JobShowPage}
            title="screens.inspection_details"
         />
         <Page
            path={ROUTES.JOBTYPES_CREATE}
            component={JobDefinitionCreatePage}
            title="screens.jobs_create_definition"
         />
      </Switch>
   </div>
)

class JobsListBase extends React.Component {
   constructor(props) {
      super(props)
      this.state = {
         loading: false,
         data: [],
         reset: false,
         perPage: 10,
         open: false,
      }
      this.storeKey = `${pageKey()}_filters`
   }

   lb = new labelHelper(
      labels,
      this.props.authUser ? this.props.authUser.lang : labelHelper.lang
   )

   /**
    * Set or get page shared components filters
    */
   filters = (filters = null) => {
      if (filters) {
         console.log('Setting new filters', filters)
         sessionStorage.setItem(this.storeKey, JSON.stringify(filters))
         this.setState({ filters })
      } else {
         return sessionStorage.getItem(this.storeKey)
            ? JSON.parse(sessionStorage.getItem(this.storeKey))
            : undefined
      }
   }

   panes = [
      {
         key: 'completedJobs',
         menuItem: this.lb._(labels.jobs.completedJobs),
         render: () => (
            <Tab.Pane key="completedJobs">
               {this.shouldRender() ? (
                  <TableComponent
                     list={list}
                     filters={{ ...this.filters(), status: ['completed'] }}
                     {...this.props}
                     parent={this} // give access to page context so button can change state and display modal
                  />
               ) : (
                  <MandatoryWarning />
               )}
            </Tab.Pane>
         ),
      },
      {
         key: 'pendingJobs',
         menuItem: this.lb._(labels.jobs.pendingJobs),
         render: () => (
            <Tab.Pane key="pendingJobs">
               {this.shouldRender() ? (
                  <TableComponent
                     list={list}
                     filters={{
                        status: ['pending,queued,converting,downloading', 'in'],
                        ...this.filters(),
                     }}
                     {...this.props}
                  />
               ) : (
                  <MandatoryWarning />
               )}
            </Tab.Pane>
         ),
      },
   ]

   render() {
      return (
         <Container>
            <Grid columns="equal">
               <Grid.Column>
                  <AutoHeader />
               </Grid.Column>
               <Grid.Column textAlign="right">
                  <TranslatedButton
                     link={ROUTES.JOBTYPES_CREATE}
                     label="screens.jobs_create_definition"
                     icon="cogs plus"
                  />
                  {/* <TranslatedButton
                     link={ROUTES.USER_INVITE}
                     label="screens.user_invite"
                     icon="mail"
                  /> */}
               </Grid.Column>
            </Grid>
            <Container>
               <SearchComponent
                  form={search}
                  data={this.filters()}
                  {...this.props}
                  propagate={filters => this.filters(filters)}
               />
            </Container>
            <Divider />
            <TabWidget panes={this.panes} />
         </Container>
      )
   }

   /**
    * Should the content be rendered ?
    * if user is partner, they must choose a company
    */
   shouldRender() {
      return (
         (this.filters() && this.filters().company) ||
         [ROLES.ROLE_ROOT, ROLES.ROLE_ADMIN].includes(this.props.authUser.role)
      )
   }
}

const condition = authUser => authUser // && !!authUser.roles[ROLES.ADMIN]

const JobsList = withAuthentication(JobsListBase)

export default compose(withAuthorization(condition))(JobsPage)
